import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import * as ServiceProxy from '../../../../../base/proxy/serviceProxy'
import { ServiceCallTypeEnum } from '../../../../../base/models'

export interface CancelCreditRequest {
  OrderId: string
  SerialNumber: string
  DealerCode: string
}

export interface CancelCreditResponse {
  Success: boolean
  Message: string
  ErrorCode?: string
}

export class CancelCreditApi extends ClientProxy {
  constructor(props: any = {}) {
    super({
      url: 'compay-payment/cancel-serial-credit',
      ...props,
    })
  }

  public async cancelCredit(request: CancelCreditRequest): Promise<CancelCreditResponse> {
    const response = await ServiceProxy.Call<CancelCreditResponse>(
      ServiceCallTypeEnum.Post,
      'Post',
      this.props,
      request
    )
    return response.data as CancelCreditResponse
  }
}
